module.exports = __webpack_public_path__ + "d7.no2.5fb68f1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d7.no2.jpg
// module id = Belk
// module chunks = 0